import { InvoiceData } from "@/types";
import { GetterTree } from "vuex";
import { BillingState, RootState } from "@/types/store/clientzone";

export const getters: GetterTree<BillingState, RootState> = {
  GET_INVOICES: (state): Array<InvoiceData> => [...state.invoices].filter(invoice => invoice.amount != '0'),
  GET_INVOICE_NUMBER: (state): Function => (invoiceId: number) => state.invoices.find(i => i.id === invoiceId).invoiceNumber,
  GET_INVOICES_TOTAL_COUNT: (state) => state.invoicesTotalCount
}
